export default {
  // Sizes
  headerHeight: '80px',
  panelWidth: 250
};
